
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/WorldCup2026",
      function () {
        return require("private-next-pages/WorldCup2026/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/WorldCup2026"])
      });
    }
  